import { createSelector } from "reselect";
import { getFlyerDetailPageState } from "../../../store/flyer-detail-page.store";
import { FlyerDetailPageState } from "../../../types/flyer-detail-page-state/flyer-detail-page-state.interface";
import { FlyerDetailPageFormPageState } from "../types/flyer-detail-page-form-page-state/flyer-detail-page-form-page-state.interface";
import Store from "../../../../../../../../../redux/store";
import * as actions from "./flyer-detail-page-form-page.actions";
import { FlyerDetailPageForm } from "../types/flyer-detail-page-form.interface";

const getFlyerDetailPageFormPageState = createSelector(
  getFlyerDetailPageState,
  (state?: FlyerDetailPageState) => state?.flyerDetailPageFormPageState
);

export const getPage = createSelector(
  getFlyerDetailPageFormPageState,
  (state?: FlyerDetailPageFormPageState) => state?.page
);

export const isLoading = createSelector(
  getFlyerDetailPageFormPageState,
  (state?: FlyerDetailPageFormPageState) => state?.isLoading || false
);

export function fetchPage() {
  Store.dispatch(actions.fetchPage());
}

export function savePage(changes: FlyerDetailPageForm) {
  Store.dispatch(actions.savePage(changes));
}
